import { API, API_POST } from "../../Config";

export const handleAddController = (payload) => {
  const f = new FormData();
  console.log("c", payload);
  f.append("email", payload.email);
  f.append("password", payload.password);
  f.append("privileges", payload.privillges);

  return API_POST(API.AddController, f);
};
